import { SVGProps } from "react";

const GIBlank = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width="1em" height="1em" {...props}><circle cx={128} cy={128} r={128} /><circle stroke="#fff" strokeWidth={18} cx={128} cy={128} r={101} /><path d="MZ" /></svg>;

export { GIBlank };